import React from "react";

export default function AccordionSummary({
  accordionItem,
  expandAccordion,
  setExpandAccordion,
  icons,
  summaryContent,
  children,
  storeAccordionStatus,
  expandOnIconClickOnly,
}) {
  const bgSummaryColor = accordionItem?.bgSummaryColor || "bg-white";
  const SummaryContentVariant = summaryContent;
  const handleAccordionExpansion = () => {
    setExpandAccordion(!expandAccordion);
    storeAccordionStatus();
  };

  const defaultClassNames = !expandAccordion
    ? bgSummaryColor + " w-full shadow-md mb-4 p-4 rounded"
    : "bg-white w-full shadow-md mb-4 p-4 rounded";

  return (
    <div
      className={accordionItem?.summaryClasses ?? defaultClassNames}
      style={{ backgroundColor: bgSummaryColor }}
    >
      <div
        className={`flex w-full flex-row items-center justify-between ${
          expandOnIconClickOnly ? "" : "hover:cursor-pointer"
        }`}
        {...(!expandOnIconClickOnly && {
          onClick: handleAccordionExpansion,
        })}
      >
        <SummaryContentVariant accordionItem={accordionItem} />
        <div
          onClick={(e) => {
            if (expandOnIconClickOnly) {
              e.stopPropagation();
              handleAccordionExpansion();
            }
          }}
          className={expandOnIconClickOnly ? "cursor-pointer" : ""}
        >
          {expandAccordion ? icons?.shrinkIcon : icons?.expandIcon}
        </div>
      </div>

      {expandAccordion && accordionItem ? React.cloneElement(children, { accordionItem }) : ""}
    </div>
  );
}
